import type { CrmMessages } from "./englishCrmMessages";

export const germanCrmMessages = {
  resources: {
    leads: {
      name: "Lead |||| Leads",
      forcedCaseName: "Lead",
      fields: {
        name: "Name",
        phone: "Telefon",
        email: "E-Mail",
        source: "Quelle",
        campaign: "Kampagne",
        status: "Status",
        created_at: "Eingegangen",
        first_response_seconds: "Erstkontakt",
        claim_seconds: "Übernommen nach",
        sales_id: "Zuständig",
      },
      status: {
        neu: "Neu",
        uebernommen: "Übernommen",
        erreicht: "Erreicht",
        termin: "Termin",
        abschluss: "Abschluss",
        verloren: "Verloren",
      },
      source: {
        meta: "Meta",
        google: "Google",
        landingpage: "Landingpage",
        whatsapp: "WhatsApp",
        manuell: "Manuell",
      },
      filter: {
        open: "Offen",
        mine: "Meine",
      },
      action: {
        claim: "Übernehmen",
        call: "Anrufen",
        send: "Senden",
        message_title: "Per WhatsApp antworten",
        message_placeholder: "Ihre Nachricht an den Lead",
      },
      notification: {
        claimed: "Lead übernommen nach %{duration}.",
        message_sent: "Nachricht gesendet.",
        status_changed: "Status geändert.",
      },
      timeline: {
        title: "Verlauf",
        empty: "Noch keine Ereignisse.",
      },
      event: {
        created: "Lead eingegangen",
        whatsapp_out: "WhatsApp gesendet",
        whatsapp_in: "WhatsApp empfangen",
        whatsapp_skipped: "WhatsApp nicht gesendet",
        whatsapp_failed: "Nachricht fehlgeschlagen",
        team_notified: "Team benachrichtigt",
        team_notify_failed: "Team-Benachrichtigung fehlgeschlagen",
        claimed: "Übernommen",
        escalated: "Eskaliert",
        status_changed: "Status geändert",
        document: "Dokument empfangen",
      },
      empty: {
        description: "Neue Leads aus euren Kampagnen erscheinen hier.",
      },
    },
    companies: {
      name: "Unternehmen |||| Unternehmen",
      forcedCaseName: "Unternehmen",
      fields: {
        name: "Unternehmensname",
        website: "Website",
        linkedin_url: "LinkedIn-URL",
        phone_number: "Telefonnummer",
        created_at: "Erstellt am",
        nb_contacts: "Anzahl Kontakte",
        revenue: "Umsatz",
        sector: "Branche",
        size: "Größe",
        tax_identifier: "Steuernummer",
        address: "Adresse",
        city: "Stadt",
        zipcode: "PLZ",
        state_abbr: "Bundesland",
        country: "Land",
        description: "Beschreibung",
        context_links: "Kontext-Links",
        sales_id: "Kundenbetreuer",
      },
      empty: {
        description: "Ihre Unternehmensliste ist anscheinend leer.",
        title: "Keine Unternehmen gefunden",
      },
      import: {
        title: "Unternehmen importieren",
      },
      field_categories: {
        contact: "Kontakt",
        additional_info: "Weitere Informationen",
        address: "Adresse",
        context: "Kontext",
      },
      action: {
        create: "Unternehmen anlegen",
        edit: "Unternehmen bearbeiten",
        new: "Neues Unternehmen",
        show: "Unternehmen anzeigen",
      },
      added_on: "Hinzugefügt am %{date}",
      followed_by: "Betreut von %{name}",
      followed_by_you: "Von Ihnen betreut",
      no_contacts: "Kein Kontakt",
      nb_contacts: "%{smart_count} Kontakt |||| %{smart_count} Kontakte",
      nb_deals: "%{smart_count} Deal |||| %{smart_count} Deals",
      sizes: {
        one_employee: "1 Mitarbeiter",
        two_to_nine_employees: "2–9 Mitarbeiter",
        ten_to_forty_nine_employees: "10–49 Mitarbeiter",
        fifty_to_two_hundred_forty_nine_employees: "50–249 Mitarbeiter",
        two_hundred_fifty_or_more_employees: "250 oder mehr Mitarbeiter",
      },
      autocomplete: {
        create_error:
          "Beim Anlegen des Unternehmens ist ein Fehler aufgetreten",
        create_item: "%{item} anlegen",
        create_label: "Tippen, um ein neues Unternehmen anzulegen",
      },
    },
    contacts: {
      name: "Kontakt |||| Kontakte",
      forcedCaseName: "Kontakt",
      field_categories: {
        background_info: "Hintergrund",
        identity: "Identität",
        misc: "Sonstiges",
        personal_info: "Persönliche Angaben",
        position: "Position",
      },
      fields: {
        first_name: "Vorname",
        last_name: "Nachname",
        last_seen: "Zuletzt gesehen",
        title: "Position",
        company_id: "Unternehmen",
        email_jsonb: "E-Mail-Adressen",
        email: "E-Mail",
        phone_jsonb: "Telefonnummern",
        phone_number: "Telefonnummer",
        linkedin_url: "LinkedIn-URL",
        background: "Hintergrund (Bio, wie Sie sich kennengelernt haben usw.)",
        has_newsletter: "Newsletter abonniert",
        sales_id: "Kundenbetreuer",
      },
      action: {
        add: "Kontakt hinzufügen",
        add_first: "Ersten Kontakt hinzufügen",
        create: "Kontakt anlegen",
        edit: "Kontakt bearbeiten",
        export_vcard: "Als vCard exportieren",
        new: "Neuer Kontakt",
        show: "Kontakt anzeigen",
      },
      background: {
        last_activity_on: "Letzte Aktivität am %{date}",
        added_on: "Hinzugefügt am %{date}",
        followed_by: "Betreut von %{name}",
        followed_by_you: "Von Ihnen betreut",
        status_none: "Keiner",
      },
      position_at: "%{title} bei",
      position_at_company: "%{title} bei %{company}",
      empty: {
        description: "Ihre Kontaktliste ist anscheinend leer.",
        title: "Keine Kontakte gefunden",
      },
      import: {
        title: "Kontakte importieren",
      },
      inputs: {
        genders: {
          male: "Er/Ihm",
          female: "Sie/Ihr",
          nonbinary: "Keine Angabe/Divers",
        },
        personal_info_types: {
          work: "Geschäftlich",
          home: "Privat",
          other: "Sonstige",
        },
      },
      list: {
        error_loading: "Fehler beim Laden der Kontakte",
      },
      bulk_tag: {
        action: "Taggen",
        back: "Zurück zu den Tags",
        create_description:
          "Neuen Tag anlegen und den ausgewählten Kontakten zuweisen.",
        description:
          "Wählen Sie einen vorhandenen Tag oder legen Sie einen neuen für die ausgewählten Kontakte an.",
        empty:
          "Noch keine Tags vorhanden. Legen Sie einen an, um die ausgewählten Kontakte zu taggen.",
        error: "Tag konnte den Kontakten nicht hinzugefügt werden",
        noop: "Die ausgewählten Kontakte haben diesen Tag bereits",
        success:
          "Tag zu %{smart_count} Kontakt hinzugefügt |||| Tag zu %{smart_count} Kontakten hinzugefügt",
        title: "Tag zu Kontakten hinzufügen",
      },
      merge: {
        action: "Mit anderem Kontakt zusammenführen",
        confirm: "Kontakte zusammenführen",
        current_contact: "Aktueller Kontakt (wird gelöscht)",
        description: "Diesen Kontakt mit einem anderen zusammenführen.",
        error: "Kontakte konnten nicht zusammengeführt werden",
        merging: "Wird zusammengeführt...",
        no_additional_data: "Keine zusätzlichen Daten zum Zusammenführen",
        select_target: "Bitte wählen Sie einen Kontakt zum Zusammenführen aus",
        success: "Kontakte erfolgreich zusammengeführt",
        target_contact: "Zielkontakt (bleibt erhalten)",
        title: "Kontakt zusammenführen",
        warning_description:
          "Alle Daten werden auf den zweiten Kontakt übertragen. Diese Aktion kann nicht rückgängig gemacht werden.",
        warning_title: "Achtung: Unwiderrufliche Aktion",
        what_will_be_merged: "Was zusammengeführt wird:",
      },
      filters: {
        before_last_month: "Vor letztem Monat",
        before_this_month: "Vor diesem Monat",
        before_this_week: "Vor dieser Woche",
        managed_by_me: "Von mir betreut",
        search: "Name, Unternehmen suchen...",
        this_week: "Diese Woche",
        today: "Heute",
        tags: "Tags",
        tasks: "Aufgaben",
      },
      hot: {
        empty_change_status:
          "Ändern Sie den Status eines Kontakts, indem Sie ihm eine Notiz hinzufügen und auf „Optionen anzeigen“ klicken.",
        empty_hint: "Kontakte mit dem Status „heiß“ erscheinen hier.",
        title: "Heiße Kontakte",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Beschreibung",
        company_id: "Unternehmen",
        contact_ids: "Kontakte",
        category: "Kategorie",
        amount: "Budget",
        expected_closing_date: "Erwarteter Abschluss",
        stage: "Phase",
      },
      action: {
        back_to_deal: "Zurück zum Deal",
        create: "Deal anlegen",
        new: "Neuer Deal",
      },
      field_categories: {
        misc: "Sonstiges",
      },
      filters: {
        only_mine: "Nur meine Deals",
      },
      archived: {
        action: "Archivieren",
        error: "Fehler: Deal wurde nicht archiviert",
        list_title: "Archivierte Deals",
        success: "Deal archiviert",
        title: "Archivierter Deal",
        view: "Archivierte Deals anzeigen",
      },
      inputs: {
        linked_to: "Verknüpft mit",
      },
      unarchived: {
        action: "Zurück aufs Board",
        error: "Fehler: Deal wurde nicht wiederhergestellt",
        success: "Deal wiederhergestellt",
      },
      updated: "Deal aktualisiert",
      empty: {
        before_create: "bevor Sie einen Deal anlegen.",
        description: "Ihre Deal-Liste ist anscheinend leer.",
        title: "Keine Deals gefunden",
      },
      import: {
        title: "Deals importieren",
      },
      invalid_date: "Ungültiges Datum",
    },
    notes: {
      name: "Notiz |||| Notizen",
      forcedCaseName: "Notiz",
      fields: {
        status: "Status",
        date: "Datum",
        attachments: "Anhänge",
        contact_id: "Kontakt",
        deal_id: "Deal",
      },
      action: {
        add: "Notiz hinzufügen",
        add_first: "Erste Notiz hinzufügen",
        delete: "Notiz löschen",
        edit: "Notiz bearbeiten",
        update: "Notiz aktualisieren",
        add_this: "Diese Notiz hinzufügen",
      },
      sheet: {
        create: "Notiz anlegen",
        create_for: "Notiz für %{name} anlegen",
        edit: "Notiz bearbeiten",
        edit_for: "Notiz für %{name} bearbeiten",
      },
      deleted: "Notiz gelöscht",
      empty: "Noch keine Notizen",
      author_added: "%{name} hat eine Notiz hinzugefügt",
      you_added: "Sie haben eine Notiz hinzugefügt",
      me: "Ich",
      list: {
        error_loading: "Fehler beim Laden der Notizen",
      },
      note_for_contact: "Notiz für %{name}",
      stepper: {
        hint: "Öffnen Sie einen Kontakt und fügen Sie eine Notiz hinzu",
      },
      added: "Notiz hinzugefügt",
      inputs: {
        add_note: "Notiz hinzufügen",
        options_hint: "(Dateien anhängen oder Details ändern)",
        show_options: "Optionen anzeigen",
      },
      actions: {
        attach_document: "Dokument anhängen",
      },
      validation: {
        note_or_attachment_required:
          "Eine Notiz oder ein Anhang ist erforderlich",
      },
    },
    sales: {
      name: "Teammitglied |||| Teammitglieder",
      fields: {
        first_name: "Vorname",
        last_name: "Nachname",
        email: "E-Mail",
        administrator: "Admin",
        disabled: "Deaktiviert",
      },
      create: {
        error: "Beim Anlegen des Teammitglieds ist ein Fehler aufgetreten.",
        success:
          "Teammitglied angelegt. Es erhält in Kürze eine E-Mail, um sein Passwort festzulegen.",
        title: "Neues Teammitglied anlegen",
      },
      edit: {
        error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
        record_not_found: "Datensatz nicht gefunden",
        success: "Teammitglied erfolgreich aktualisiert",
        title: "%{name} bearbeiten",
      },
      action: {
        new: "Neues Teammitglied",
      },
    },
    tasks: {
      name: "Aufgabe |||| Aufgaben",
      forcedCaseName: "Aufgabe",
      fields: {
        text: "Beschreibung",
        due_date: "Fälligkeitsdatum",
        type: "Typ",
        contact_id: "Kontakt",
        due_short: "fällig",
      },
      action: {
        add: "Aufgabe hinzufügen",
        create: "Aufgabe anlegen",
        edit: "Aufgabe bearbeiten",
      },
      actions: {
        postpone_next_week: "Auf nächste Woche verschieben",
        postpone_tomorrow: "Auf morgen verschieben",
        title: "Aufgabenaktionen",
      },
      added: "Aufgabe hinzugefügt",
      deleted: "Aufgabe erfolgreich gelöscht",
      dialog: {
        create: "Aufgabe anlegen",
        create_for: "Aufgabe für %{name} anlegen",
      },
      sheet: {
        edit: "Aufgabe bearbeiten",
        edit_for: "Aufgabe für %{name} bearbeiten",
      },
      empty: "Noch keine Aufgaben",
      empty_list_hint: "Aufgaben zu Ihren Kontakten erscheinen hier.",
      filters: {
        later: "Später",
        overdue: "Überfällig",
        this_week: "Diese Woche",
        today: "Heute",
        tomorrow: "Morgen",
        with_pending: "Mit offenen Aufgaben",
      },
      regarding_contact: "(Betr.: %{name})",
      updated: "Aufgabe aktualisiert",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Tag hinzufügen",
        create: "Neuen Tag anlegen",
      },
      dialog: {
        color: "Farbe",
        create_title: "Neuen Tag anlegen",
        edit_title: "Tag bearbeiten",
        name_label: "Tag-Name",
        name_placeholder: "Tag-Namen eingeben",
      },
    },
  },
  crm: {
    kpi: {
      title: "Kennzahlen",
      total: "Leads",
      open_hint: "%{count} offen",
      count_hint: "%{count} Leads",
      response_median: "Erstkontakt (Median)",
      within_target: "%{percent} % unter 60 Sek.",
      claim_median: "Übernahme (Median)",
      reached_rate: "Kontaktquote",
      appointment_rate: "Terminquote",
      close_rate: "Abschlussquote",
      by_sales: "Nach Vertriebler",
      by_source: "Nach Quelle",
      by_campaign: "Nach Kampagne",
      unassigned: "Nicht übernommen",
      last_days: "%{days} Tage",
    },
    action: {
      reset_password: "Passwort zurücksetzen",
    },
    auth: {
      first_name: "Vorname",
      last_name: "Nachname",
      confirm_password: "Passwort bestätigen",
      confirmation_required:
        "Bitte folgen Sie dem Link, den wir Ihnen gerade per E-Mail gesendet haben, um Ihr Konto zu bestätigen.",
      recovery_email_sent:
        "Wenn Sie registriert sind, erhalten Sie in Kürze eine E-Mail zur Wiederherstellung Ihres Passworts.",
      sign_in_failed: "Anmeldung fehlgeschlagen.",
      sign_in_google_workspace: "Mit Google Workspace anmelden",
      signup: {
        create_account: "Konto erstellen",
        create_first_user:
          "Legen Sie das erste Benutzerkonto an, um die Einrichtung abzuschließen.",
        creating: "Wird erstellt...",
        initial_user_created: "Erstes Benutzerkonto erfolgreich angelegt",
      },
      welcome_title: "Willkommen bei Atomic CRM",
    },
    common: {
      account_manager: "Kundenbetreuer",
      activity: "Aktivität",
      added: "hinzugefügt",
      details: "Details",
      last_activity_with_date: "letzte Aktivität %{date}",
      load_more: "Mehr laden",
      misc: "Sonstiges",
      past: "Vergangen",
      read_more: "Mehr lesen",
      retry: "Erneut versuchen",
      show_less: "Weniger anzeigen",
      copied: "Kopiert!",
      copy: "Kopieren",
      loading: "Wird geladen...",
      me: "Ich",
      task_count: "%{smart_count} Aufgabe |||| %{smart_count} Aufgaben",
    },
    changelog: {
      title: "Änderungsprotokoll",
    },
    activity: {
      added_company: "%{name} hat ein Unternehmen hinzugefügt",
      you_added_company: "Sie haben ein Unternehmen hinzugefügt",
      added_contact: "%{name} hat hinzugefügt",
      you_added_contact: "Sie haben hinzugefügt",
      added_note: "%{name} hat eine Notiz hinzugefügt zu",
      you_added_note: "Sie haben eine Notiz hinzugefügt zu",
      added_note_about_deal: "%{name} hat eine Notiz zum Deal hinzugefügt",
      you_added_note_about_deal: "Sie haben eine Notiz zum Deal hinzugefügt",
      added_deal: "%{name} hat einen Deal hinzugefügt",
      you_added_deal: "Sie haben einen Deal hinzugefügt",
      at_company: "bei",
      to: "zu",
      load_more: "Weitere Aktivitäten laden",
    },
    dashboard: {
      deals_chart: "Erwarteter Deal-Umsatz",
      deals_pipeline: "Deal-Pipeline",
      latest_activity: "Letzte Aktivitäten",
      latest_activity_error: "Fehler beim Laden der letzten Aktivitäten",
      latest_notes: "Meine letzten Notizen",
      latest_notes_added_ago: "hinzugefügt %{timeAgo}",
      stepper: {
        install: "Atomic CRM installieren",
        progress: "%{step}/3 erledigt",
        whats_next: "Wie geht es weiter?",
      },
      upcoming_tasks: "Anstehende Aufgaben",
    },
    data_import: {
      button: "CSV importieren",
      complete:
        "Import abgeschlossen. %{importCount} Datensätze importiert, %{errorCount} Fehler",
      csv_file: "CSV-Datei",
      error:
        "Die Datei konnte nicht importiert werden. Bitte stellen Sie sicher, dass es sich um eine gültige CSV-Datei handelt.",
      progress:
        "%{importCount} / %{rowCount} Datensätze importiert, %{errorCount} Fehler.",
      remaining_time: "Geschätzte Restzeit:",
      resource: "Ressource",
      running: "Der Import läuft, bitte schließen Sie diesen Tab nicht.",
      sample_download: "CSV-Beispiel herunterladen",
      sample_hint:
        "Hier ist eine Beispiel-CSV-Datei, die Sie als Vorlage verwenden können",
      start: "Import starten",
      stop: "Import stoppen",
      title: "Daten importieren",
    },
    header: {
      import_data: "Aus JSON importieren",
    },
    image_editor: {
      change: "Ändern",
      drop_hint:
        "Datei zum Hochladen hierher ziehen oder klicken, um sie auszuwählen.",
      editable_content: "Bearbeitbarer Inhalt",
      title: "Bild hochladen und zuschneiden",
      update_image: "Bild aktualisieren",
    },
    import: {
      action: {
        download_error_report: "Fehlerbericht herunterladen",
        import: "Importieren",
        import_another: "Weitere Datei importieren",
      },
      error: {
        unable: "Diese Datei kann nicht importiert werden.",
      },
      idle: {
        description_1:
          "Sie können Teammitglieder, Unternehmen, Kontakte, Notizen und Aufgaben importieren.",
        description_2:
          "Die Daten müssen in einer JSON-Datei nach folgendem Muster vorliegen:",
      },
      status: {
        all_success: "Alle Datensätze wurden erfolgreich importiert.",
        complete: "Import abgeschlossen.",
        failed: "Fehlgeschlagen",
        imported: "Importiert",
        in_progress: "Import läuft, bitte verlassen Sie diese Seite nicht.",
        some_failed: "Einige Datensätze wurden nicht importiert.",
        table_caption: "Importstatus",
      },
      title: "Aus JSON importieren",
    },
    settings: {
      about: "Über",
      companies: {
        sectors: "Branchen",
      },
      dark_mode_logo: "Logo (Dunkelmodus)",
      deals: {
        categories: "Kategorien",
        currency: "Währung",
        pipeline_help:
          "Wählen Sie, welche Deal-Phasen zur Pipeline zählen sollen.",
        pipeline_statuses: "Pipeline-Status",
        stages: "Phasen",
      },
      light_mode_logo: "Logo (Hellmodus)",
      notes: {
        statuses: "Status",
      },
      reset_defaults: "Auf Standard zurücksetzen",
      save_error: "Konfiguration konnte nicht gespeichert werden",
      saved: "Konfiguration erfolgreich gespeichert",
      saving: "Wird gespeichert...",
      tasks: {
        types: "Typen",
      },
      preferences: "Einstellungen",
      title: "Einstellungen",
      app_title: "App-Titel",
      sections: {
        branding: "Branding",
      },
      validation: {
        duplicate: "Doppelte %{display_name}: %{items}",
        in_use:
          "%{display_name}, die noch von Deals verwendet werden, können nicht entfernt werden: %{items}",
        validating: "Wird geprüft…",
        entities: {
          categories: "Kategorien",
          stages: "Phasen",
        },
      },
    },
    theme: {
      dark: "Dunkel",
      label: "Design",
      light: "Hell",
      system: "System",
    },
    language: "Sprache",
    navigation: {
      label: "CRM-Navigation",
    },
    profile: {
      inbound: {
        description:
          "Sie können E-Mails an die eingehende E-Mail-Adresse Ihres Servers senden, z. B. indem Sie sie in das Feld %{field} eintragen. Atomic CRM verarbeitet die E-Mails und fügt den entsprechenden Kontakten Notizen hinzu.",
        title: "Eingehende E-Mails",
      },
      mcp: {
        title: "MCP-Server",
        description:
          "Verwenden Sie diese URL, um Ihren KI-Assistenten über das Model Context Protocol (MCP) mit Ihren CRM-Daten zu verbinden.",
      },
      password: {
        change: "Passwort ändern",
      },
      password_reset_sent:
        "Eine E-Mail zum Zurücksetzen des Passworts wurde an Ihre E-Mail-Adresse gesendet",
      record_not_found: "Datensatz nicht gefunden",
      title: "Profil",
      updated: "Ihr Profil wurde aktualisiert",
      update_error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut",
    },
    validation: {
      invalid_url: "Muss eine gültige URL sein",
      invalid_linkedin_url: "URL muss von linkedin.com stammen",
    },
  },
} satisfies CrmMessages;
